import React from 'react';
import PropTypes from 'prop-types';
import GapChoicePlaceholder from './GapChoicePlaceholder';
import stringUtils from '../../../../qti/utils/StringUtils';
import styles from './dragAndDropInteraction.scss';

class GapChoicesContainer extends React.PureComponent {
    static propTypes = {
        gapChoiceModels: PropTypes.array.isRequired,
        mediaTracker: PropTypes.object.isRequired,
        onElement: PropTypes.func.isRequired,
    };

    static getContainerMinHeight(gapChoiceModels) {
        return gapChoiceModels.reduce((minHeight, gapChoiceModel) => {
            const { height } = gapChoiceModel.geography;
            return height > minHeight ? height : minHeight;
        }, 0);
    }

    render() {
        try {
            const { gapChoiceModels, mediaTracker, onElement } = this.props;
            const style = { minHeight: GapChoicesContainer.getContainerMinHeight(gapChoiceModels) };

            return (
                <div
                    className={`${styles.gapChoicesContainer}`}
                    style={style}
                    ref={onElement}
                >
                    {
                        gapChoiceModels.map((gapChoiceModel) => {
                            return (
                                <GapChoicePlaceholder
                                    gapChoiceModel={gapChoiceModel}
                                    key={`gapChoiceInContainer-${stringUtils.getUID()}`}
                                    mediaTracker={mediaTracker}
                                />
                            );
                        })
                    }
                </div>
            );
        } catch (error) {
            return null;
        }
    }
}

export default GapChoicesContainer;
